module.exports = __webpack_public_path__ + "img/店外三件套.024bf3c1.png";